class StopViewModel extends App.Models.BaseModel {
    modelUrl = 'StopView';
}

App.Models.StopView = StopViewModel;
